import type { Environments } from '@/types';
import request from '@/utils/request';

export const getEnvironments = async (): Promise<Environments> => {
  const url = '/api/v1/environments/';

  return (await request.get<Environments>(url)).data;
};
